const resources = {
  "en": {
    "register": {
      "title": "🆕 Create Account",
      "nameLabel": "Name",
      "emailLabel": "Email",
      "passwordLabel": "Password",
      "registerButton": "Register",
      "loginLink": "Back to login",
      "emailSent": "Verification email sent. Please check your inbox and confirm your email.",
      "invitedBy": "You were invited by {{name}}",
      "inviteSubtitle": "Complete registration to unlock a free month and earn {{points}} bonus points.",
      "inviteInvalid": "Invitation link is no longer valid.",
      "inviteUnknown": "your friend",
      "friendsInviteTitle": "Friends plan invite detected",
      "friendsInviteDescription": "Finish registration and complete your profile to unlock the Friends plan: 5 AI requests/month for 4 months.",
      "legalConsentPrefix": "I agree to the",
      "termsLink": "Terms",
      "legalConsentAnd": "and",
      "privacyLink": "Privacy Policy",
      "legalConsentRequired": "You must accept the current Terms and Privacy Policy to create an account.",
      "legalDetailsButton": "Review details",
      "legalDetailsTitle": "Terms and Privacy details",
      "legalDetailsIntro": "These are the current documents you accept when creating an account.",
      "legalDocumentVersion": "version {{version}}, effective {{effectiveDate}}",
      "readTerms": "Read Terms",
      "readPrivacy": "Read Privacy Policy",
      "legalDetailsClose": "Close"
    }
  },
  "uk": {
    "register": {
      "title": "🆕 Створити акаунт",
      "nameLabel": "Ім’я",
      "emailLabel": "Електронна пошта",
      "passwordLabel": "Пароль",
      "registerButton": "Зареєструватися",
      "loginLink": "Назад до входу",
      "emailSent": "Лист підтвердження надіслано. Перевірте вхідні та підтвердьте електронну адресу.",
      "invitedBy": "Вас запросив(ла) {{name}}",
      "inviteSubtitle": "Завершіть реєстрацію, щоб отримати безкоштовний місяць і {{points}} бонусних балів.",
      "inviteInvalid": "Посилання-запрошення більше не дійсне.",
      "inviteUnknown": "ваш друг",
      "friendsInviteTitle": "Запрошення на Friends-тариф",
      "friendsInviteDescription": "Завершіть реєстрацію та заповніть профіль, щоб активувати Friends: 5 AI-запитів/місяць протягом 4 місяців.",
      "legalConsentPrefix": "Я погоджуюся з",
      "termsLink": "Умовами",
      "legalConsentAnd": "та",
      "privacyLink": "Політикою конфіденційності",
      "legalConsentRequired": "Потрібно прийняти актуальні Умови та Політику конфіденційності, щоб створити акаунт.",
      "legalDetailsButton": "Переглянути деталі",
      "legalDetailsTitle": "Деталі Умов і Політики",
      "legalDetailsIntro": "Це актуальні документи, які ви приймаєте під час створення акаунта.",
      "legalDocumentVersion": "версія {{version}}, чинна з {{effectiveDate}}",
      "readTerms": "Читати Умови",
      "readPrivacy": "Читати Політику конфіденційності",
      "legalDetailsClose": "Закрити"
    }
  }
};

export default resources;
